module.exports = __webpack_public_path__ + "img/envelopes.3bd0889e.svg";